<template>
    <v-client-table ref="oshaNewsTable" :columns="columns" :options="options" :data="news_items">
        <template slot="title" slot-scope="props">
            <a :href="props.row.url" target="_blank">{{ props.row.title }}</a>
        </template>
    </v-client-table>
</template>

<script>
export default {
    data: function() {
        return {
            news_items: [],
            columns: ['title'],
            options: {
                columnsDropdown: false,
                headings: {
                    title: 'Title',
                },
                filterable: false,
            }
        }
    },

    methods: {
        getData: function() {
            this.$http.get('/dash/osha-news')
            .then(response => {
                this.news_items = response.data;
                this.$emit('firstNewsItem', response.data[0].title);
            })
            .catch(err => {

            })
            .then(() => {

            });
        },
    },

    mounted() {
        this.getData();
    },
}
</script>
